/**
 * API Configuration - PRODUCTION FIRST
 * 
 * DEFAULT: Production Cloud Run URL
 * Local development: Only when explicitly enabled via VITE_USE_LOCAL_API=true
 * 
 * This prevents accidental localhost deployments.
 */

// ============================================================
// PRODUCTION CONFIGURATION (DO NOT CHANGE)
// ============================================================
const PRODUCTION_API_URL = 'https://magnus-backend-933555815330.us-east1.run.app';

import { getEnv, getBooleanEnv } from './env';

// ============================================================
// ENVIRONMENT DETECTION
// ============================================================
const VITE_API_URL = getEnv('VITE_API_URL');
const VITE_USE_LOCAL_API = getBooleanEnv('VITE_USE_LOCAL_API');

// Detect if we're running on localhost
const isLocalHost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);

// ============================================================
// API URL RESOLUTION - PRODUCTION FIRST
// ============================================================

let API_BASE_URL_RESOLVED: string;

if (VITE_API_URL) {
    // 1. Explicit env var takes priority (allows overriding for any environment)
    API_BASE_URL_RESOLVED = VITE_API_URL;
} else if (isLocalHost && VITE_USE_LOCAL_API) {
    // 2. Local development ONLY if explicitly enabled AND running on localhost
    API_BASE_URL_RESOLVED = 'http://localhost:8000';
    console.log('🔧 LOCAL DEV MODE: Using localhost:8000 (VITE_USE_LOCAL_API=true)');
} else {
    // 3. DEFAULT: Use relative path (relies on Firebase hosting rewrites)
    API_BASE_URL_RESOLVED = '';
}

// Log configuration for debugging
if (typeof window !== 'undefined') {
    console.log(`🔗 API Configuration:`);
    console.log(`   → Base URL: ${API_BASE_URL_RESOLVED}`);
    console.log(`   → Is Localhost: ${isLocalHost}`);
    console.log(`   → Local API Enabled: ${VITE_USE_LOCAL_API}`);
    if (API_BASE_URL_RESOLVED === PRODUCTION_API_URL) {
        console.log(`   ✅ Using PRODUCTION backend`);
    }
}

export const API_BASE_URL = API_BASE_URL_RESOLVED;

// Common API endpoints
export const API_ENDPOINTS = {
    projects: {
        list: `${API_BASE_URL}/api/projects/`,
        load: (name: string) => `${API_BASE_URL}/api/projects/load/${encodeURIComponent(name)}`,
        save: `${API_BASE_URL}/api/projects/save`,
        storageMode: `${API_BASE_URL}/api/projects/config/storage-mode`,
    },
    visualization: {
        syncEpochs: `${API_BASE_URL}/api/visualization/sync-epochs`,
        epochFiles: `${API_BASE_URL}/api/visualization/epoch-files`,
        fullEpochs: (filename: string) => `${API_BASE_URL}/api/visualization/full-epochs?filename=${encodeURIComponent(filename)}&t=${Date.now()}`,
        deleteFile: (filename: string) => `${API_BASE_URL}/api/visualization/delete-file?filename=${encodeURIComponent(filename)}`,
    }
} as const;

